import {CodeDeliveryMethod} from "@simplyhealth/iam_client_lib/lib/shared/models";

export type UserStatus = "Unknow" | "Error" | "LoggedIn" | "NotLoggedIn";

export interface CodeDeliveryDto {
    codeDeliveryMethod: CodeDeliveryMethod;
    codeDeliveryDestination: string;
    realCodeDeliveryDestination: string;
}

export function createCodeDeliveryDto(
    codeDeliveryMethod: CodeDeliveryMethod,
    codeDeliveryDestination: string,
    realCodeDeliveryDestination: string,
): CodeDeliveryDto {
    return {
        codeDeliveryMethod,
        codeDeliveryDestination,
        realCodeDeliveryDestination,
    };
}